module.exports = __webpack_public_path__ + "img/img6.3b8f84f1.png";